export const questionnaireConstants = {
  questionTitleMaxLength: 30,
};
